import React from "react";
import PropTypes from 'prop-types'

const ChatBotButton = ({ text, color, onClick, style, isdisabled, ...props }) => {
    return (
        <button
            className={`flex flex-row bg-white rounded-md px-2 py-1 
                        items-center justify-center w-flex ${style} ${isdisabled ? "cursor-not-allowed" : "hover:opacity-80"}`}
            onClick={onClick} disabled={isdisabled}
        >
            <div>
                {props.children}
            </div>
            <p className={`text-black `}>{text}</p>
        </button>
    )
}

ChatBotButton.propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    url: PropTypes.string,
}

export default ChatBotButton
